import React from 'react';
import PropTypes from 'prop-types';

export function SvgQadra({ stroke = '#000000', 'aria-label': ariaLabel = 'icon-qadra' }) {
  return (
    <svg
      aria-label={ariaLabel}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill={stroke}
          d="M17.913 14.825h-1.828V5H5v11.085h9.825v1.828a3.087 3.087 0 103.088-3.088zm-11.653 0V6.26h8.565v8.565H6.26zm11.653 4.915a1.827 1.827 0 01-1.828-1.825v-1.828h1.828a1.827 1.827 0 010 3.653z"
        />
      </g>
    </svg>
  );
}

SvgQadra.propTypes = {
  stroke: PropTypes.string,
  'aria-label': PropTypes.string,
};
